<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&#8230;</div>
    <div class="loading" v-if="isLoading">Loading&#8230;</div>
    <div class="row mt-3">
        <div class="col d-flex justify-content-start">
          <h4>Clientes</h4>
        <h4>Consolidado Anual - Cajas vs. Egresos</h4>
      </div>
    </div>
    <div class="card bg-light rounded-sm p-3 my-2 border">
      <!------------- FILTROS ----------------->
      <div class="row d-flex justify-content-between">
        <div class="col col-md-2">
          <div class="form-group">
            <select v-if="fundCategoriesLoaded" v-model="filters.category_id" class="custom-select" style="width: 208px;">
              <option :value="null">- Categorías de caja -</option>
              <option v-for="category in filteredCategories" :key="category.id" :value="category.id" v-html="category.name"></option>
            </select>
            <div v-else>
              Cargando categorías...
            </div>
          </div>
        </div>
        <!------------- BOTONES ----------------->
        <div class="col col-md-1">
          <input type="button" @click="exportCSV()" class="btn btn-md btn-outline-primary" value="Exportar CSV">
        </div>
      </div>
    </div>  
    <!------------- TABLA ----------------->
    <div class="row">
      <div class="col">
        <div class="table-responsive">
        <table class="table table-striped table-sm mt-2">
            <thead class="thead-light">
                <tr>
                    <th></th>
                    <th>Enero</th>
                    <th>Febrero</th>
                    <th>Marzo</th>
                    <th>Abril</th>
                    <th>Mayo</th>
                    <th>Junio</th>
                    <th>Julio</th>
                    <th>Agosto</th>
                    <th>Septiembre</th>
                    <th>Octubre</th>
                    <th>Noviembre</th>
                    <th>Diciembre</th>
                    <th>Consolidado</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(item, index) in incomes" :key="index" :class="isSpecialRow(item)">
                    <td>{{ item.name }}</td>
                    <td>{{ formatoDinamicoMoneda(item.enero) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.febrero) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.marzo) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.abril) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.mayo) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.junio) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.julio) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.agosto) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.septiembre) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.octubre) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.noviembre) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.diciembre) }}</td>
                    <td>{{ formatoDinamicoMoneda(item.consolidado) }}</td>
                </tr>
            </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { mapState } from 'vuex'
  import formatMoneyMixin from "../../mixins/formatMoneyMixin";

  
  export default {
    mixins: [formatMoneyMixin],
    data: function() {
      return {
        isLoading: false,
        incomes: [],
        filters:{
          category_id:null,
        },
       
      };
    },
    mounted() {
      this.getData();
    },
    computed: {
      ...mapState('fundsCategory',{
        fundsCategories: state => state.fundsCategories,
      }),
      ...mapState('fundsCategory', {
        loading: state => state.loading,
      }),
      fundCategoriesLoaded() {
        return Array.isArray(this.fundsCategories);
      },
      filteredCategories() {
        const filtered = [];
        this.fundsCategories.forEach(category => {
          if(category.type === 'out'){
            filtered.push(category);
          }
        });
        return filtered;
      },
    },
    created () {
      this.$store.dispatch('fundsCategory/getFundsCategories').then(() => {
      
      })
    },
    methods: {
      getData(){
        var vm= this;
        axios.post('/api/reports/getConsolidated',vm.filters)
          .then(response => {
            if(response.data.success) {
                vm.incomes = response.data.data;
            }else{
                vm.incomes=[];
            }
        })
        .catch(error => {
            alert(error);
        })
      },
      exportCSV(){
        let vm = this;
        axios.post('/api/reports/CSVConsolidated', vm.filters)
        .then(() => {
        });
      },
      isSpecialRow(item) {
        switch (item.name) {
          case 'INGRESOS':
            return 'ingresos-row';
          case 'EGRESOS':
            return 'egresos-row';
          case 'RESULTADO OPERATIVO':
            return 'resultado-operativo-row';
          case 'RENDIMIENTO':
            return 'rendimiento-row';
          default:
            return '';
        }
      },
    },
    watch: {
      'filters.category_id': {handler: function () {this.getData();}},
    },
  };
  </script>

  <style>
  .active {
    font-weight: 800;
  }
  .ingresos-row {
    background-color: lightgreen !important; 
  }

  .egresos-row {
    background-color:  rgba(232, 29, 29, 0.796)!important; 
  }

  .resultado-operativo-row {
    background-color: rgb(253, 202, 19); 
  }

  .rendimiento-row {
    background-color: rgb(253, 253, 116) !important;
  }
  </style>